import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableWithoutFeedback } from 'react-native';

import { View } from 'react-native';

import Text from '../text';
import { format } from 'date-fns';

import CalendarSelectedDateGlow from './calendar-selected-date-glow';
import styles from './calendar.styles';

import SimpleDate from '../date';

const DATE_FORMAT = 'DD MMMM YYYY';

export default class CalendarSelectedDate extends PureComponent {
  static propTypes = {
    fromDate: PropTypes.instanceOf(Date),
    toDate: PropTypes.instanceOf(Date),
    selectingDate: PropTypes.oneOf(['from', 'to']),
    onChange: PropTypes.func,
    noDateText: PropTypes.string,
  };

  static defaultProps = {
    selectingDate: 'from',
    noDateText: 'Choose a date',
  };

  onSelectFrom = () => {
    this.onSelect('from');
  };

  onSelectTo = () => {
    this.onSelect('to');
  };

  onSelect(value) {
    const { onChange } = this.props;

    if (onChange) {
      onChange(value);
    }
  }

  render() {
    const {selectingDate, fromDate, toDate, messages} = this.props;
    let fromFormatedDate = format(fromDate, DATE_FORMAT);
    let toFormatedDate = format(toDate, DATE_FORMAT);
    return (
      <div className="row">
        <TouchableWithoutFeedback onPress={this.onSelectFrom}>
          <div className="small-6 large-6 columns selectedDateSplitter fromDate">
            <Text type="secondary">{messages['app.calendar.fromText']}</Text>
            <View style={styles.dateContainerIE}>
              {fromDate ?
                <SimpleDate renderProps={{ type: 'secondary' }} value={fromFormatedDate} />
                :
                <Text>{messages['app.calendar.chooseAdate']}</Text>
              }
              <CalendarSelectedDateGlow visible={selectingDate === 'from'} />
            </View>
          </div>
        </TouchableWithoutFeedback>
        <TouchableWithoutFeedback onPress={this.onSelectTo}>
          <div className="small-6 large-6 columns toDate">
            <Text type="secondary">{messages['app.common.calendar.to']}</Text>
            <View>
              {toDate ?
                <SimpleDate renderProps={{ type: 'secondary' }} value={toFormatedDate} />
                :
                <Text>{messages['app.calendar.chooseAdate']}</Text>
              }
              <CalendarSelectedDateGlow visible={selectingDate === 'to'} />
            </View>
          </div>
        </TouchableWithoutFeedback>
      </div>);
  }
}
